import { useQuery } from 'react-query'
import { getAnalyticsToolboxLocation } from '../api/connections'

export function useATLocation({ connectionId, region }: { connectionId?: string; region?: string }) {
  const { data: atLocation } = useQuery({
    queryKey: ['useATLocation', connectionId, region],
    queryFn: async () => (connectionId ? getAnalyticsToolboxLocation({ connectionId, region }) : undefined),
    enabled: Boolean(connectionId)
  })

  return { atLocation }
}
